import { useMemo } from "react"

export type Filter<DataItem> = (item: DataItem) => boolean

type Props<DataItem> = {
  data: DataItem[]
  filters: Filter<DataItem>[]
}

export const useFilteredData = <DataItem>({
  data,
  filters,
}: Props<DataItem>) => {
  const filteredData = useMemo(() => {
    return filters.reduce<DataItem[]>((acc, filter) => {
      return acc.filter(filter)
    }, data)
  }, [data, filters])

  return filteredData
}
